export default 'vehicleTracking';
